import React from 'react';
import dayjs from 'dayjs';
import { useApplication } from '../../hooks';
import { TStep } from '../steps';
import { TermsModal } from './terms-modal';
import SidebarApplication from './SidebarApplication';

interface ApplicationLayoutProps {
  step: TStep;
  children: React.DetailedReactHTMLElement<any, HTMLElement>;
}

export default function ApplicationLayout({
  step,
  children,
}: ApplicationLayoutProps) {
  const [application] = useApplication();
  const today = dayjs(new Date());
  const finalDate = dayjs(new Date(2026, 6, 1));
  return (
    <div className="w-full h-full min-h-screen bg-white overflow-x-hidden flex flex-row">
      <div className="hidden lg:block w-full max-w-[360px] max-h-screen overflow-y-auto bg-dark-blue">
        <SidebarApplication step={step} />
      </div>
      <div className="flex-1 max-h-screen overflow-y-auto flex flex-col">
        {React.cloneElement(children, { application })}
        <footer className="w-full py-4 px-6 bg-dark-blue mt-auto">
          <p className="text-white text-sm">
            This site is best viewed using the current browser version of
            Chrome, Edge, Opera, Firefox and Safari. If you are using an
            out-of-date browser you may not experience the full effect when
            viewing the site.
          </p>
          <p className="text-white text-xs ">
            © 2022 - {new Date().getFullYear()}. Carreras Limited
          </p>
        </footer>
      </div>
      {today.isAfter(finalDate) ? <TermsModal /> : null}
    </div>
  );
}
